import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class MtuExceptionService {

    isValid(): boolean {
        return false;
    }
}
